<template>
	<div>
		<p class="text-sm leading-5 font-semibold tracking-wider text-gray-400 uppercase">
		Subscribe to our newsletter
		</p>
		<p class="mt-4 text-gray-300 text-base leading-6">
		The latest news, articles, and resources, sent to your inbox.
		</p>
		<div class="mt-3" v-show="(feedback.message) ? true : false">
			<tw-alert :type="feedback.type" :show="(feedback.message) ? true : false">{{ feedback.message }}</tw-alert>
		</div>
		<div class="mt-4 sm:flex sm:max-w-md">
			<input aria-label="Email address" autocomplete="email" type="email" name="email" class="appearance-none w-full px-5 py-3 border border-transparent text-base leading-6 rounded-md text-gray-900 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 transition duration-150 ease-in-out" placeholder="Enter your email" v-model="form.email"/>
			<div class="mt-3 rounded-md shadow sm:mt-0 sm:ml-3 sm:flex-shrink-0">
				<button class="w-full flex items-center justify-center px-5 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-teal-600 focus:outline-none focus:bg-teal-400 transition duration-150 ease-in-out" @click="create">
				Subscribe
				</button>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'subscribe',
		data() {
			return {
				form: {
					email: ''
				},
				feedback: {
					type: '',
					message: false,
				}
			}
		},
		methods: {
			create() {
				const self = this;

				axios.post('subscribe', this.form)
					 .then((resp) => {
					 	if(resp.data) {
					 		self.form.email = '';
					 		self.feedback.type 		= (resp.data.success) ? 'success' : 'error';
					 		self.feedback.message 	= resp.data.message;

					 		setTimeout(function() {
					 			self.feedback.type 		= '';
					 			self.feedback.message 	= false;
					 		}, 5000)
					 	}
					 });
			}
		}
	}
</script>